<template>
  <div :class="['accordion-customizable-fi', themeClass, colorSchema]">
    <div
      class="accordion-customizable-fi__panels"
      data-test="accordion-customizable-panels"
    >
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import setupAccordion from '@/components/atoms/accordion/setupAccordion';

defineOptions({
  name: 'AccordionCustomizableWrapperFi',
});

setupAccordion();

const props = defineProps<{
  theme?: string;
  color?: string;
}>();

const colorSchema = computed(() => (props.color ? `accordion--${props.color}` : ''));
const themeClass = computed(() => (props.theme ? `accordion--${props.theme}-theme` : ''));
</script>

<style src="./accordion-customizable-fi" />
